/* eslint-disable -- generado por npm run jotform:setup */
/**
 * AUTO-GENERADO — no edites a mano salvo que sepas los qid.
 * Regenerar: npm run jotform:setup
 */
export const jotformContactFormId = "260905580357158";

export const jotformEmailFormId = "260905855570160";

export const jotformContactQids: Record<string, string> = {
  "language": "1",
  "first_name": "2",
  "last_name": "3",
  "email": "4",
  "phone": "5",
  "business_name": "6",
  "industry": "7",
  "funding_amount": "8",
  "years_in_business": "9",
  "preferred_plan": "10",
  "notes": "11"
};

export const jotformEmailQids: Record<string, string> = {
  "email": "1",
  "source": "2"
};
